import axios from 'axios';

const GENERIC_MESSAGE = 'Não foi possível concluir a operação, tente novamente';

const handle = (error) => {
  // Busca cancelada por uma nova busca: não é erro para o usuário.
  if (axios.isCancel(error)) {
    return { success: false, errors: {} };
  }

  // Timeout do axios: usa a mensagem configurada em api.js.
  if (error.code === 'ECONNABORTED') {
    return { success: false, errors: {}, message: error.message || GENERIC_MESSAGE };
  }

  // Sem response: rede caiu, CORS ou o servidor morreu antes de responder.
  if (!error.response) {
    return { success: false, errors: {}, message: GENERIC_MESSAGE };
  }

  if (error.response.status === 422) {
    if (error.response.data.errors) {
      return { success: false, errors: error.response.data.errors };

    } else if (error.response.data.message) {
      return { success: false, errors: {}, message: error.response.data.message };
    }

    return { success: false, errors: {}, message: GENERIC_MESSAGE };
  }

  // O interceptor já desloga no 401 e redireciona no 404; avisar de novo confunde.
  if (error.response.status === 401 || error.response.status === 404) {
    return { success: false, errors: {} };
  }

  if (error.response.data && error.response.data.message) {
    return { success: false, errors: {}, message: error.response.data.message };
  }

  return { success: false, errors: {}, message: GENERIC_MESSAGE };
};

export default {
  handle,
};
